import _         from 'lodash'
import React     from 'react'
import PropTypes from 'prop-types'

import { AdminForm, AdminTable, AdminPage } from 'alto-react-components/lib/components'
import CanteenRepository, { Terminal }      from 'alto-react-canteen/lib/models'

class TerminalTable extends AdminTable
  @contextTypes = { backend: PropTypes.object }

  model: Terminal

  constructor: (props, context) ->
    super(props, context)

    @state.canteens        = null
    @state.ready           = false
    @state.notReadyMessage = 'Načítám seznam jídelen'

    repository = CanteenRepository.forBackend(context.backend)

    repository.canteens.all().then (canteens) => @setState({ canteens, ready: true })

  columns: ->
    canteenOptions = @state.canteens.map (canteen) -> [canteen.name, canteen.name]

    [{
      property: 'name'
      header:
        label: 'Název'
        formatters: [@orderableAndFilterable()]
      filter:
        matcher: 'icontains'
     }, {
      property: 'ip'
      header:
        label: 'IP adresa'
        formatters: [@orderableAndFilterable()]
      filter:
        matcher: 'icontains'
     }, {
       _property: 'defaultCanteen.name'
       property: (terminal) -> terminal.associations.defaultCanteen?.name
       header:
         label: 'Výchozí jídelna'
         formatters: [@orderableAndFilterable(type: 'select', options: canteenOptions)]
       filter:
         matcher: 'icontains'
     }, {
      property: 'registeredAt'
      header:
        label: 'Registrován'
        formatters: [@orderable]
      cell:
        formatters: [(timestamp) -> timestamp.locale('cs').format('LLL')]
     }]

class TerminalForm extends AdminForm
  @contextTypes = { backend: PropTypes.object }

  model:      Terminal
  createText: 'Registrovat'

  defaultValues:
    ip: 'bude automaticky vyplněna'

  constructor: (props, context) ->
    super(props, context)

    @state.canteens        = null
    @state.ready           = false
    @state.notReadyMessage = 'Načítám seznam jídelen'

    repository = CanteenRepository.forBackend(context.backend)

    repository.canteens.all().then (canteens) => @setState({ canteens, ready: true })

  inputs: ->
    canteenOptions = @state.canteens.map (canteen) -> [canteen.name, canteen.id]

    [{
      label:     'Název'
      property:  'name'
      validator: 'notEmpty'
    }, {
      type:      'static'
      label:     'IP adresa'
      property:  'ip'
    }, {
      type:       'select'
      label:      'Výchozí jídelna'
      property:   'defaultCanteenID'
      options:    canteenOptions
      allowBlank: true
    }]

  submit: ->
    @props.submit(_.pick(@state.values, 'name', 'defaultCanteenID'))

export default class TerminalManagement extends AdminPage
  @contextTypes = { backend: PropTypes.object }

  relation: ->
    @__relation ||= CanteenRepository.forBackend(@context.backend).terminals.with('defaultCanteen')

  tableComponent: TerminalTable
  formComponent:  TerminalForm

  afterCreate: (terminal) -> window.localStorage.setItem('terminal-secret', terminal.secret)
  afterUpdate: (terminal) -> window.localStorage.setItem('terminal-secret', terminal.secret)
